// @flow

import bucky from 'bucky';
import { DISABLED_PROVIDER } from '.';
import type { Provider } from '.';

type Config = {
  host: ?string,
  prefix: ?string,
  isEnabled: boolean,
  sendLatency?: boolean,
  aggregationInterval?: number,
  globalTags: string[]
}

export default (config: Config): Provider => {
  const {
    host,
    prefix,
    isEnabled = true,
    sendLatency = true,
    aggregationInterval = 2000,
    globalTags = []
  } = config;

  if (isEnabled && host) {
    bucky.setOptions({
      host,
      sendLatency,
      aggregationInterval
    });

    const addPrefix = path => `${prefix || ''}.${path}`;

    return {
      count: (path, tags) => bucky.count(addPrefix(path), [...globalTags, ...tags]),
      timing: (path, duration, tags) => bucky.timer.send(addPrefix(path), duration, [...globalTags, ...tags]),
      gauge: (path, value, tags) => bucky.send(addPrefix(path), value, [...globalTags, ...tags]),
      sendPagePerformance: tags => bucky.sendPagePerformance(addPrefix('performance'), [...globalTags, ...tags])
    };
  }

  return DISABLED_PROVIDER;
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/metrics/client.js
 **/